<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.isilive.ca/"> {{ $t("footer.brand") }} </a>
          </li>
          <li>
            <button type="button" class="footer-link-btn" @click="logout">
              {{ $t("footer.logout") }}
            </button>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        {{ $t("footer.copyright") }}
        <a href="https://www.isilive.ca/" target="_blank">{{
          $t("footer.brand")
        }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
import { appendLangParam } from "@/i18n";
import axios from "axios";
import { ISI_API_URL } from "../../config";
export default {
  data() {
    return {
      ISI_API_URL: ISI_API_URL,
    };
  },
  methods: {
    async logout() {
      // /logout clears the isi_token cookie and (on Kratos) revokes the IdP
      // session, then hands back the login_url to land on.
      let loginUrl = null;
      try {
        const res = await axios.get(ISI_API_URL + "logout", {
          withCredentials: true,
        });
        loginUrl = res.data && res.data.login_url;
      } catch (err) {
        // fall through — still leave the app
      }
      window.location.href = appendLangParam(loginUrl) || "/";
    },
  },
};
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 260px; /* Account for sidebar width */
  right: 0;
  background: rgb(var(--v-theme-surface-muted));
  border-top: 1px solid rgb(var(--v-theme-border-subtle));
  padding: 15px 30px;
  z-index: 100;
  font-size: 12px;
  color: rgb(var(--v-theme-text-muted));
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: none;
  padding: 0;
}

.footer nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.footer nav ul li {
  margin-right: 25px;
}

.footer nav ul li a,
.footer nav ul li .footer-link-btn {
  color: rgb(var(--v-theme-text-muted));
  text-decoration: none;
  font-size: 12px;
  transition: all 0.3s;
}

/* The logout control is a real <button> for keyboard/AT users, styled to
   match the footer links. */
.footer-link-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
}

.footer nav ul li a:hover,
.footer nav ul li .footer-link-btn:hover {
  color: rgb(var(--v-theme-on-surface));
}

.footer .copyright {
  font-size: 12px;
  color: rgb(var(--v-theme-text-muted));
}

.footer .copyright a {
  color: rgb(var(--v-theme-text-muted));
  text-decoration: none;
}

.footer .copyright a:hover {
  color: rgb(var(--v-theme-on-surface));
}

/* Responsive */
@media (max-width: 991px) {
  .footer {
    left: 0;
  }
}
</style>
